import { createContext, useCallback, useContext, useMemo, useState } from 'react';

// ==============================|| CONTEXTO - MODO DO ADMIN (PRODUÇÃO / SANDBOX) ||============================== //
// O admin escolhe o modo no header; as páginas enviam ?livemode=1|0 nos pedidos.

const STORAGE_KEY = 'gpo_admin_mode';

const readMode = () => {
  try {
    return window.localStorage.getItem(STORAGE_KEY) === 'test' ? 'test' : 'live';
  } catch {
    return 'live';
  }
};

const AdminModeContext = createContext(null);

export const AdminModeProvider = ({ children }) => {
  const [mode, setModeState] = useState(readMode);

  const setMode = useCallback((next) => {
    if (next !== 'live' && next !== 'test') return;
    try {
      window.localStorage.setItem(STORAGE_KEY, next);
    } catch {
      // sem localStorage: o modo vale só para esta sessão
    }
    setModeState(next);
  }, []);

  const value = useMemo(
    () => ({ mode, isLive: mode === 'live', livemode: mode === 'live' ? 1 : 0, setMode }),
    [mode, setMode]
  );

  return <AdminModeContext.Provider value={value}>{children}</AdminModeContext.Provider>;
};

export const useAdminMode = () => {
  const context = useContext(AdminModeContext);
  if (!context) throw new Error('useAdminMode deve ser usado dentro de <AdminModeProvider>');
  return context;
};
